/**
* @ngdoc service
* @name catalog.product.service:ProductInfoService
* @description
* Product Info data manipulation.
*/
(function() {
    'use strict';

    angular
    .module('itxApp.catalog')
    .service('ProductInfoService', ProductInfoService);

    ProductInfoService.$inject = [
    ];

    function ProductInfoService (

    ) {
        var _this = this;

        _this.shippingMethods = [];

        var service =  {
        };

        return service;


        
    }

})();